import { isThreadListMemberOverlay } from '../../thread-list-member-overlay/operators/isThreadListMemberOverlay';
import ConnectedThreadListMemberOverlay from '../../thread-list-member-overlay/components/ConnectedThreadListMemberOverlay';
import ThreadListMemberRowContainer from '../containers/ThreadListMemberRowContainer';
import { NavMarker } from 'react-rhumb';
import { getAssociatedTicketIds, getThreadId } from 'find-and-filter-data/view-members-schema/protected';
import PreviewCardSkeletonState from '../../preview-card/components/PreviewCardSkeletonState';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
/**
 * @description threadListMemberRowGenerator reqires function, not component
 * @param {string} data - memoized result of threadListMembers,onSelectThread and focusedThreadListMember
 */
export const threadListMemberRowGenerator = data =>
// eslint-disable-next-line react/display-name
({
  index,
  key,
  style
}) => {
  const {
    onSelectThread,
    focusedThreadListMember,
    threadListMembers,
    isAssociatedTicketOpen,
    moveAndAssignError
  } = data;
  const threadListMemberOrOverlay = threadListMembers.getIn([index]);
  const threadId = getThreadId(threadListMemberOrOverlay);
  const focusedThreadId = getThreadId(focusedThreadListMember);
  const associatedTicketIds = getAssociatedTicketIds(focusedThreadListMember);
  let focusedThreadListMemberHasTickets = false;
  if (focusedThreadListMember) {
    focusedThreadListMemberHasTickets = associatedTicketIds.length !== 0;
  }
  if (!threadListMemberOrOverlay) {
    return (
      /*#__PURE__*/
      // @bend-expect trellis-tokenized style prop provided by react-virtualized List component for virtualized row positioning
      _jsx("div", {
        style: style,
        children: /*#__PURE__*/_jsx(PreviewCardSkeletonState, {})
      }, key)
    );
  }

  // See: https://github.com/bvaughn/react-window/pull/211
  if (isThreadListMemberOverlay(threadListMemberOrOverlay)) {
    const overlay = threadListMemberOrOverlay;
    return (
      /*#__PURE__*/
      // @bend-expect trellis-tokenized style prop provided by react-virtualized List component for virtualized row positioning
      _jsxs("div", {
        style: style,
        children: [/*#__PURE__*/_jsx(NavMarker, {
          name: "THREAD_LIST_SUCCESS"
        }), /*#__PURE__*/_jsx(ConnectedThreadListMemberOverlay, {
          overlay: overlay,
          focusedThreadListMemberHasTickets: focusedThreadListMemberHasTickets
          // @ts-expect-error ts-migrate(2322) FIXME: Type '{ overlay: any; focusedThreadListMemberHasTi... Remove this comment to see the full error message
          ,
          isAssociatedTicketOpen: isAssociatedTicketOpen,
          moveAndAssignError: moveAndAssignError
        })]
      }, key)
    );
  }
  const threadListMember = threadListMemberOrOverlay;
  const selected = threadId === focusedThreadId;
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized style prop provided by react-virtualized List component for virtualized row positioning
    _jsx("div", {
      style: style,
      children: /*#__PURE__*/_jsx(ThreadListMemberRowContainer, {
        threadListMember: threadListMember,
        selected: selected,
        onSelectThread: onSelectThread,
        index: index
      }, `${key}-${threadId}`)
    }, key)
  );
};